// @core/api/endpoints/document/search_documents.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SearchDocumentsResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Search documents
 * Full-text search across document titles and block content. Returns matched documents with highlighted snippets and relevance scores.
 */
export async function SearchDocuments(
  params?: {
    limit?: string | number | boolean;
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<SearchDocumentsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/documents/search`;
  const requestOptions = options;
  return client.get<SearchDocumentsResponse>(requestPath, { ...requestOptions, params });
}
